var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2471.8 2404.7",
    style: {
      enableBackground: "new 0 0 2471.8 2404.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FF0000;stroke-width:9;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#4AF300;stroke-width:6;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#0000FF;stroke-width:3;stroke-miterlimit:10;}\n\t.st3{stroke:#000000;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#000000;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#000000;stroke-width:12;stroke-miterlimit:10;}\n\t.st6{fill:#8B00FF;}\n\t.st7{fill:#000082;}\n\t.st8{fill:#0000FF;}\n\t.st9{fill:#4AF300;}\n\t.st10{fill:#FFF300;}\n\t.st11{fill:#FF8B00;}\n\t.st12{fill:#FF0000;}\n\t.st13{fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RGB_x5F_RINGS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RGB_x5F_rings_x5F_1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "RGB_x5F_rings_x5F_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1870.8,1102.9c35.2-37.8,64.6-81,86.7-128.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1013.1,842c-4.1-25.7-6.2-52.1-6.2-79c0-106.2,33.2-204.6,89.7-285.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1870.1,1102c35.3-37.9,64.8-81.4,87-128.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1014.5,841.6c-4.1-25.6-6.2-51.8-6.2-78.6c0-106.4,33.4-205,90.3-285.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1869.4,1101.2c35.5-38.1,65-81.8,87.2-129.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1015.9,841.2c-4-25.5-6.1-51.6-6.1-78.2c0-106.6,33.6-205.4,90.8-286.3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RGB_x5F_rings_x5F_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1705.1,949.6c69.3-39.2,122-104.3,144.8-182.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1329.8,467.1c-52.9,55.5-85.4,130.6-85.4,213.3c0,45.6,9.9,88.8,27.6,127.8v0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1703.4,949.3c69.9-39.1,123-104.6,145.7-183"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1273.2,808.2c-17.8-38.9-27.7-82.2-27.7-127.9c0-82.7,32.6-157.8,85.7-213.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1702.4,948.6L1702.4,948.6c70.1-39,123.3-104.7,145.9-183.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1274.4,808.3c-17.9-38.9-27.9-82.2-27.9-127.9c0-82.7,32.7-157.8,86-213"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RGB_x5F_rings_x5F_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1451.4,490.9c-36.8,34.8-59.7,84-59.7,138.6c0,105.4,85.4,190.8,190.8,190.8c90.1,0,165.6-62.4,185.6-146.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1452.6,491.2c-36.8,34.6-59.8,83.8-59.8,138.3c0,104.8,85,189.8,189.8,189.8c89.8,0,165.1-62.4,184.8-146.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1453.8,491.6c-36.9,34.4-59.9,83.5-59.9,137.9c0,104.2,84.5,188.7,188.7,188.7c89.5,0,164.5-62.4,183.9-146"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RGB_x5F_rings_x5F_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1518.4,513.4c-22,21.5-35.6,51.4-35.6,84.6c0,65.3,52.9,118.2,118.2,118.2c55.1,0,101.4-37.7,114.5-88.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1519.4,513.8c-22,21.3-35.6,51.1-35.6,84.2c0,64.7,52.5,117.2,117.2,117.2c54.8,0,100.9-37.6,113.7-88.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1520.5,514.2c-22,21.1-35.6,50.8-35.6,83.7c0,64.1,52,116.1,116.1,116.1c54.5,0,100.2-37.5,112.7-88.1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RGB_x5F_rings_x5F_6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1558.1,530.2c-11.5,12.8-18.4,29.8-18.4,48.3c0,40.1,32.5,72.6,72.6,72.6c32.1,0,59.3-20.8,68.9-49.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1559,530.6c-11.4,12.7-18.4,29.5-18.4,47.9c0,39.5,32.1,71.6,71.6,71.6c31.8,0,58.7-20.7,68.1-49.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1560.1,531.1c-11.4,12.5-18.3,29.2-18.3,47.4c0,39,31.6,70.5,70.5,70.5c31.4,0,58-20.5,67.1-48.9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RGB_x5F_rings_x5F_7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1579.7,543.2c-4.8,7.2-7.6,15.8-7.6,25.1c0,25,20.3,45.3,45.3,45.3c17.8,0,33.1-10.2,40.6-25.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1580.6,543.6c-4.7,7-7.4,15.5-7.4,24.6c0,24.5,19.8,44.3,44.3,44.3c17.4,0,32.4-10,39.7-24.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1581.6,544.1c-4.6,6.9-7.3,15.2-7.3,24.1c0,23.9,19.3,43.2,43.2,43.2c17,0,31.7-9.8,38.8-24.1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RGB_x5F_rings_x5F_7__x28_\\u043A\\u043E\\u043F\\u0438\\u044F_x29_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1595.1,550.8c-1.1,3.1-1.7,6.3-1.7,9.8c0,15.6,12.7,28.3,28.3,28.3c8.7,0,16.5-3.9,21.7-10.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1596,551.3c-1.1,2.9-1.6,6-1.6,9.3c0,15.1,12.2,27.3,27.3,27.3c8.4,0,15.8-3.8,20.8-9.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1597,551.8c-1,2.7-1.5,5.7-1.5,8.8c0,14.5,11.7,26.2,26.2,26.2c8,0,15.1-3.6,19.9-9.2"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "pupil"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1679.2,1211.9c0,159.7-86.6,299.2-215.4,374.2c-69.1,19.3-142,29.5-217.2,29.5c-75.3,0-148.1-10.3-217.2-29.6 C900.5,1511.1,814,1371.6,814,1211.9c0-160.3,87.1-300.2,216.6-374.9c68.7-19,141.2-29.2,216-29.2s147.2,10.2,216,29.2 C1592,911.8,1679.2,1051.7,1679.2,1211.9z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1266.7,
    y1: 1217.8,
    x2: 1266.7,
    y2: 1217.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "sphere_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sphere"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1946.3,1211.7c-104.7-181-277.7-317.7-483.7-374.7c-68.7-19-141.2-29.2-216-29.2s-147.2,10.2-216,29.2 c-206,57-379,193.7-483.7,374.7 M1029.3,1586.1c69.1,19.3,142,29.6,217.2,29.6c75.3,0,148.1-10.3,217.2-29.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "546.9,1204.2 541.4,1211.8 546.9,1219.4  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "sphere_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1030.6,837c68.7-19,141.2-29.2,216-29.2s147.2,10.2,216,29.2 M1946.3,1211.7 c-104.5,180.7-277,317.1-482.5,374.4c-69.1,19.3-142,29.5-217.2,29.5c-75.3,0-148.1-10.3-217.2-29.6 c-205.5-57.2-378-193.7-482.5-374.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "1946.3,1219 1951.3,1211.7 1946.3,1204.5  "
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "rays_x5F_spectrum"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1359.3,1200.2c-1.7,17.7-6.9,31.1-10.8,41l-101.9-29.2l107.7-61.7c0.2,0.7,0.4,1.5,0.6,2.2 C1357.3,1162,1361.4,1178.5,1359.3,1200.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1354.3,1150.2l-107.7,61.7l42.2-157.5c14.1,11.7,22.7,21.5,25.3,24.4 C1325,1091.6,1344.6,1114.8,1354.3,1150.2C1354.3,1150.2,1354.3,1150.2,1354.3,1150.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1288.7,1054.5l-42.2,157.5l-123.9-211.1c7.1-0.4,15-0.6,23.4-0.4c29.6,0.9,51.5,6.9,57.7,8.7 c8.4,2.4,30.1,9.2,55.1,24.2c11.6,7,21.5,14.2,29.6,20.9v0C1288.6,1054.3,1288.6,1054.4,1288.7,1054.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1246.6,1211.9l-330.1-87.5c3.8-4.8,8-9.9,12.5-15.1c22.6-26,42.8-42.6,47.4-46.3c9.9-8.1,25.5-20.5,48.5-32.9 c12.9-7,31.2-16.7,57.4-23.3c4.3-1.1,19.3-4.7,40.4-6h0L1246.6,1211.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1246.6,1211.9l-399.8,230.8c-3.1-11.7-5.9-24.9-7.9-40.1c-3.8-28.5-3-50.6-2.5-62.8 c1.4-33.4,6.8-59,9.5-70.5c7.1-30.2,16.2-52.3,20-61c2-4.7,9.7-22,22.6-43.5c5.1-8.5,14.3-23.1,28-40.4L1246.6,1211.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1246.6,1211.9l-147.9,548.3c-10-6-17.2-10.7-20.6-13c-21.5-14.4-36.5-26.6-49.5-37.3 c-7.5-6.1-15.1-12.4-23.1-19.4c-6.5-5.7-13.2-11.8-20.2-18.6c0,0,0,0,0,0c-5.2-5.1-10.6-10.6-16.1-16.6 c-14.8-16-25.4-29.6-36.2-43.8c-0.8-1-1.6-2.1-2.4-3.1c-9.1-11.9-19.2-25.2-31.1-43.8c-9-14.2-18.2-28.7-27.6-49.2 c-7.5-16.3-11.6-29-15.6-41.2c-3-9.3-6.4-19.6-9.5-31.4l31.6-18.2L1246.6,1211.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1551.2,1771.2c0,14-1.8,27.5-5.3,40.4c-2,7.4-4.5,14.5-7.5,21.4c-20.1,4.4-34.6,6.6-39.9,7.3 c-42.3,6.1-76.5,6.5-96.1,6.1c-30.9-0.6-54-3.5-69-5.4c-20.7-2.7-52.4-6.9-92.2-18.4c-4.6-1.3-24.1-7.1-49.3-16.9 c-27.9-10.9-48.7-21.2-57.8-25.9c-13.5-6.9-25.2-13.6-34.5-19.2c0,0,0,0,0,0c-0.3-0.2-0.6-0.3-0.9-0.5l147.9-548.3l299.1,518.1 c0.1,0.3,0.1,0.5,0.2,0.8c0,0,0,0,0,0.1C1549.4,1743.7,1551.2,1757.3,1551.2,1771.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1596.4,1817.9c-6.7,2-12.7,3.7-18.2,5.3c-14.7,4.1-28.2,7.4-39.9,9.9c3-6.9,5.5-14.1,7.5-21.4 c3.5-12.9,5.3-26.5,5.3-40.4c0-14-1.8-27.5-5.3-40.4c0,0,0-0.1,0-0.1c-0.1-0.3-0.1-0.5-0.2-0.8L1596.4,1817.9z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "rays_x5F_spectrum__x28_\\u043A\\u043E\\u043F\\u0438\\u044F_x29_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1246.6,
    y1: 1211.9,
    x2: 1662.9,
    y2: 1331.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1246.6,1211.9c4.8-0.4,9.4,0,13.8,0.8c4.5,0.8,8.9,1.8,13.3,2.9c4.4,1,8.7,2.2,13.1,3.4l13.1,3.5l52,14.9 l104.1,29.8L1560,1297l52,14.9l52,15.1l-2.4,8.3l-52.1-14.7l-52-14.9l-104.1-29.8l-104.1-29.8l-52-14.9l-12.9-4 c-4.3-1.3-8.6-2.6-12.9-4c-4.3-1.4-8.5-3-12.8-4.6C1254.5,1216.8,1250.4,1214.8,1246.6,1211.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1246.6,
    y1: 1211.9,
    x2: 1621.3,
    y2: 1861
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1246.6,1211.9c5.4,5.9,10,12.3,14.3,18.8c4.3,6.6,8.4,13.2,12.5,19.8c4.1,6.7,8,13.4,12,20.1l11.9,20.2 l46.8,81.1l93.7,162.3l93.7,162.3l46.8,81.1l46.7,81.2l-7.5,4.3l-47-81l-46.8-81.1l-93.7-162.3l-93.7-162.3l-46.9-81.1l-11.5-20.4 c-3.8-6.8-7.7-13.6-11.4-20.4c-3.7-6.9-7.4-13.8-10.9-20.7C1252.2,1226.7,1248.9,1219.6,1246.6,1211.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1246.6,
    y1: 1211.9,
    x2: 1440.6,
    y2: 1935.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1246.6,1211.9c3.7,7.1,6.5,14.4,9,21.8c2.4,7.4,4.7,14.9,6.9,22.4c2.2,7.5,4.3,15,6.4,22.5l6.3,22.6 l24.2,90.5l48.5,181l48.5,181l24.3,90.5l24.1,90.5l-8.3,2.2l-24.4-90.4l-24.3-90.5l-48.5-181l-48.5-181l-24.3-90.5l-5.8-22.7 c-2-7.6-3.9-15.1-5.8-22.7c-1.8-7.6-3.6-15.2-5.2-22.9C1248.1,1227.7,1246.9,1219.9,1246.6,1211.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1246.6,
    y1: 1211.9,
    x2: 1246.6,
    y2: 1961.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1246.6,1211.9c1.7,7.8,2.5,15.6,3,23.4c0.4,7.8,0.7,15.6,0.9,23.4c0.2,7.8,0.3,15.6,0.3,23.4l0.3,23.4 l0,93.7l0,187.3l0,187.3l0,93.7l-0.2,93.7h-8.6l-0.2-93.7l0-93.7l0-187.3l0-187.3l0-93.7l0.3-23.4c0.1-7.8,0.1-15.6,0.3-23.4 c0.2-7.8,0.5-15.6,0.9-23.4C1244,1227.5,1244.8,1219.7,1246.6,1211.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1246.6,
    y1: 1211.9,
    x2: 1051.4,
    y2: 1935.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1246.6,1211.9c-0.3,8-1.6,15.7-3.2,23.4c-1.6,7.6-3.4,15.3-5.2,22.9c-1.8,7.6-3.8,15.1-5.8,22.7l-5.9,22.7 l-24.4,90.5l-48.8,180.9l-48.8,180.9l-24.4,90.5l-24.6,90.4l-8.3-2.2l24.2-90.5l24.4-90.5l48.8-180.9l48.8-180.9l24.4-90.5 l6.3-22.5c2.1-7.5,4.2-15,6.4-22.5c2.2-7.5,4.5-14.9,7-22.4C1240,1226.3,1242.8,1219,1246.6,1211.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1246.6,
    y1: 1211.9,
    x2: 871.8,
    y2: 1861
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1246.6,1211.9c-2.4,7.6-5.6,14.8-9.1,21.8c-3.5,7-7.2,13.9-10.9,20.7c-3.7,6.9-7.6,13.6-11.4,20.4 l-11.5,20.4l-46.9,81.1l-93.7,162.3L969.4,1701l-46.8,81.1l-47,81l-7.5-4.3l46.7-81.2l46.8-81.1l93.7-162.3l93.7-162.3l46.8-81.1 l11.9-20.2c4-6.7,7.9-13.5,12-20.1c4.1-6.7,8.2-13.3,12.5-19.8C1236.6,1224.2,1241.1,1217.8,1246.6,1211.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1246.6,
    y1: 1211.9,
    x2: 716.7,
    y2: 1741.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1246.6,1211.9c-4.3,6.8-9.2,12.8-14.4,18.7c-5.2,5.8-10.5,11.5-15.9,17.2c-5.4,5.7-10.9,11.2-16.3,16.8 l-16.4,16.7l-66.2,66.2L984.8,1480l-132.5,132.5l-66.2,66.2l-66.4,66.1l-6.1-6.1l66.1-66.4l66.2-66.2l132.5-132.5l132.5-132.5 l66.2-66.2l16.7-16.4c5.6-5.5,11.1-11,16.8-16.3c5.7-5.4,11.4-10.7,17.2-15.9C1233.7,1221.2,1239.8,1216.2,1246.6,1211.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1246.6,
    y1: 1211.9,
    x2: 597.6,
    y2: 1586.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1246.6,1211.9c-5.9,5.4-12.3,10-18.8,14.3c-6.6,4.3-13.2,8.4-19.8,12.5c-6.7,4.1-13.4,8-20.1,12l-20.2,11.9 l-81.1,46.8l-162.2,93.7l-162.2,93.7l-81.1,46.8l-81.2,46.7l-4.3-7.5l81-47l81.1-46.8l162.2-93.7l162.2-93.7l81.1-46.8l20.4-11.5 c6.8-3.8,13.6-7.7,20.4-11.4c6.9-3.7,13.8-7.4,20.7-10.9C1231.8,1217.5,1238.9,1214.3,1246.6,1211.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1246.6,
    y1: 1211.9,
    x2: 522.6,
    y2: 1406.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1246.6,1211.9c-7.1,3.7-14.4,6.5-21.8,9c-7.4,2.4-14.9,4.7-22.4,6.9c-7.5,2.2-15,4.3-22.5,6.4l-22.6,6.3 l-90.5,24.3l-181,48.6l-181,48.6l-90.5,24.3l-90.5,24.1l-2.2-8.3l90.4-24.5l90.5-24.3l181-48.6l181-48.6l90.5-24.3l22.7-5.8 c7.6-2,15.1-3.9,22.7-5.8c7.6-1.8,15.2-3.6,22.9-5.2C1230.8,1213.5,1238.6,1212.3,1246.6,1211.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1246.6,
    y1: 1211.9,
    x2: 550.8,
    y2: 1211.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1246.6,1211.9c-7.2,1.7-14.5,2.5-21.7,3c-7.2,0.4-14.5,0.7-21.7,0.9c-7.2,0.2-14.5,0.3-21.7,0.3l-21.7,0.3 l-87,0l-173.9,0l-173.9,0l-87,0l-87-0.2l0-8.6l87-0.2l87,0l173.9,0l173.9,0l87,0l21.7,0.3c7.2,0.1,14.5,0.1,21.7,0.3 c7.2,0.2,14.5,0.5,21.7,0.9C1232.1,1209.4,1239.3,1210.2,1246.6,1211.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1239.2,1217.2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1246.6,
    y1: 1211.9,
    x2: 662.8,
    y2: 1057.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1246.6,1211.9c-6.5,0.1-12.8-0.8-19-1.9c-6.2-1.2-12.3-2.5-18.5-4c-6.1-1.4-12.2-3-18.3-4.5l-18.3-4.6 l-73-19.3l-145.9-38.7l-145.9-38.7l-73-19.3l-72.9-19.5l2.2-8.3l73,19.2l73,19.3l145.9,38.7l145.9,38.7l73,19.3l18.2,5.1 c6.1,1.7,12.1,3.3,18.2,5.1c6,1.8,12,3.7,18,5.7C1235,1206.3,1240.9,1208.6,1246.6,1211.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1246.6,
    y1: 1211.9,
    x2: 788.6,
    y2: 950.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1246.6,1211.9c-5.6-1.2-10.8-3.3-15.8-5.5c-5-2.4-9.9-4.8-14.8-7.4c-4.9-2.5-9.7-5.2-14.5-7.9l-14.4-8 l-57.2-32.7l-114.5-65.5l-114.5-65.5l-57.2-32.7l-57.2-32.9l4.3-7.5l57.3,32.6l57.2,32.7l114.5,65.5l114.5,65.5l57.3,32.7 l14.2,8.4c4.7,2.8,9.5,5.6,14.2,8.5c4.7,2.9,9.3,5.9,13.9,9C1238.3,1204.3,1242.7,1207.7,1246.6,1211.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1246.6,
    y1: 1211.9,
    x2: 911.2,
    y2: 880.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1246.6,1211.9c-4.7-2.2-8.8-5.1-12.6-8.2c-3.8-3.2-7.5-6.4-11.1-9.7c-3.6-3.3-7.2-6.7-10.7-10.1l-10.7-10.2 l-41.9-41.4l-83.8-82.9l-83.8-82.9L950,925.1l-41.8-41.6l6.1-6.1l42,41.3l41.9,41.4l83.8,82.9l83.8,82.9l41.9,41.4l10.3,10.5 c3.4,3.5,6.9,7,10.3,10.6c3.4,3.6,6.6,7.3,9.8,11C1241.4,1203.2,1244.3,1207.2,1246.6,1211.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1246.6,
    y1: 1211.9,
    x2: 1027.3,
    y2: 838.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1246.6,1211.9c-3.8-3-6.8-6.5-9.5-10.1c-2.6-3.7-5.2-7.4-7.6-11.2c-2.5-3.8-4.8-7.7-7.1-11.5l-7.1-11.5 l-27.4-46.7l-54.8-93.4l-54.8-93.4l-27.4-46.7l-27.2-46.8l7.4-4.4l27.6,46.6l27.4,46.7l54.8,93.4l54.8,93.4l27.4,46.7l6.6,11.8 c2.2,3.9,4.5,7.8,6.6,11.8c2.1,4,4.1,8,6.1,12.1C1244.2,1202.9,1245.8,1207.2,1246.6,1211.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1246.6,
    y1: 1211.9,
    x2: 1137.3,
    y2: 815.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1246.6,1211.9c-2.8-3.7-4.7-7.6-6.3-11.6c-1.5-4-3-8.1-4.3-12.2c-1.3-4.1-2.5-8.2-3.7-12.3l-3.7-12.3 l-13.6-49.6l-27.3-99.2l-27.3-99.2l-13.7-49.6l-13.5-49.6l8.3-2.3l13.8,49.5l13.7,49.6l27.3,99.2l27.3,99.2l13.7,49.6l3.2,12.5 c1.1,4.2,2.2,8.3,3.1,12.5c1,4.2,1.8,8.4,2.5,12.6C1246.7,1203,1247.1,1207.3,1246.6,1211.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1246.6,
    y1: 1211.9,
    x2: 1245.5,
    y2: 807.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1246.6,1211.9c-1.8-4.2-2.6-8.4-3.1-12.6c-0.4-4.2-0.7-8.4-0.9-12.6c-0.2-4.2-0.3-8.4-0.4-12.6l-0.3-12.6 l-0.1-50.5l-0.3-101l-0.3-101l-0.1-50.5l0.1-50.5l8.6,0l0.3,50.5l0.1,50.5l0.3,101l0.3,101l0.1,50.5l-0.2,12.6 c-0.1,4.2-0.1,8.4-0.3,12.6c-0.2,4.2-0.5,8.4-0.9,12.6C1249.1,1203.5,1248.3,1207.7,1246.6,1211.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1246.6,
    y1: 1211.9,
    x2: 1353,
    y2: 814.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1246.6,1211.9c-0.6-4.6-0.2-8.9,0.4-13.2c0.7-4.2,1.5-8.5,2.4-12.6c0.9-4.2,2-8.3,3-12.5l3.1-12.5 l13.3-49.6l26.6-99.3l26.6-99.3l13.3-49.6l13.5-49.6l8.3,2.2l-13.1,49.7l-13.3,49.6l-26.6,99.3l-26.6,99.3l-13.3,49.7l-3.6,12.3 c-1.2,4.1-2.3,8.2-3.6,12.3c-1.3,4.1-2.7,8.1-4.2,12.2C1251.2,1204.3,1249.4,1208.2,1246.6,1211.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1246.6,
    y1: 1211.9,
    x2: 1463.1,
    y2: 836.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1246.6,1211.9c0.7-4.8,2.3-9.1,4.1-13.2c1.9-4.1,3.9-8.2,6-12.2c2.1-4,4.3-7.9,6.5-11.9l6.5-11.8l27.1-46.9 l54.1-93.8l54.1-93.8l27.1-46.9l27.2-46.8l7.5,4.3l-26.9,47l-27.1,46.9l-54.1,93.8l-54.1,93.8l-27.1,46.9l-7,11.6 c-2.3,3.9-4.6,7.8-7,11.6c-2.4,3.8-4.9,7.6-7.6,11.3C1253.3,1205.4,1250.3,1208.9,1246.6,1211.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1246.6,
    y1: 1211.9,
    x2: 1552.7,
    y2: 905.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1246.6,1211.9c2-4.4,4.6-8.2,7.4-11.7c2.9-3.5,5.9-6.9,8.9-10.2c3-3.3,6.2-6.6,9.3-9.8l9.4-9.7l38.3-38.3 l76.5-76.5l76.5-76.5l38.3-38.3l38.4-38.1l6.1,6.1l-38.1,38.4l-38.3,38.3l-76.5,76.5l-76.5,76.5l-38.3,38.3l-9.7,9.4 c-3.2,3.1-6.5,6.3-9.8,9.3c-3.3,3.1-6.7,6-10.2,8.9C1254.7,1207.3,1251,1210,1246.6,1211.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1246.6,
    y1: 1211.9,
    x2: 1622.3,
    y2: 996.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1246.6,1211.9c3-3.8,6.6-6.7,10.2-9.4c3.7-2.6,7.5-5.1,11.3-7.5c3.8-2.4,7.7-4.7,11.6-7l11.6-6.9l47-26.9 l93.9-53.8l93.9-53.8l47-26.9l47.1-26.7l4.3,7.5l-46.9,27.1l-47,26.9l-93.9,53.8l-93.9,53.8l-47,26.9l-11.9,6.5 c-3.9,2.2-7.9,4.4-11.9,6.4c-4,2.1-8.1,4.1-12.2,5.9C1255.6,1209.6,1251.3,1211.2,1246.6,1211.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1246.6,
    y1: 1211.9,
    x2: 1665.5,
    y2: 1102.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1246.6,1211.9c3.9-2.8,8.1-4.7,12.3-6.4c4.3-1.5,8.5-3,12.9-4.3c4.3-1.3,8.7-2.5,13-3.7l13-3.7l52.4-13.7 l104.7-27.4l104.7-27.4l52.4-13.7l52.4-13.5l2.2,8.3l-52.3,13.9l-52.4,13.7l-104.7,27.4l-104.7,27.4l-52.4,13.7l-13.2,3.2 c-4.4,1.1-8.8,2.2-13.2,3.1c-4.4,1-8.9,1.8-13.3,2.6C1255.9,1212.1,1251.4,1212.5,1246.6,1211.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1246.6,
    y1: 1211.9,
    x2: 1679.5,
    y2: 1214.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1246.6,1211.9c4.5-1.7,9-2.5,13.6-2.9c4.5-0.4,9-0.7,13.5-0.8c4.5-0.2,9-0.2,13.5-0.2l13.5-0.2l54.1,0.4 l108.2,0.7l108.2,0.7l54.1,0.4l54.1,0.6l-0.1,8.6l-54.1-0.2l-54.1-0.4l-108.2-0.7l-108.2-0.7l-54.1-0.4l-13.5-0.3 c-4.5-0.1-9-0.2-13.5-0.4c-4.5-0.2-9-0.6-13.5-1C1255.6,1214.5,1251.1,1213.7,1246.6,1211.9z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "sphere__x28_\\u043A\\u043E\\u043F\\u0438\\u044F_x29_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sphere__x28_\\u043A\\u043E\\u043F\\u0438\\u044F_x29__2_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1946.3,1211.7c-104.7-181-277.7-317.7-483.7-374.7c-68.7-19-141.2-29.2-216-29.2s-147.2,10.2-216,29.2 c-206,57-379,193.7-483.7,374.7 M1029.3,1586.1c69.1,19.3,142,29.6,217.2,29.6c75.3,0,148.1-10.3,217.2-29.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "546.9,1204.2 541.4,1211.8 546.9,1219.4  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "sphere__x28_\\u043A\\u043E\\u043F\\u0438\\u044F_x29__1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1030.6,837c68.7-19,141.2-29.2,216-29.2s147.2,10.2,216,29.2 M1946.3,1211.7 c-104.5,180.7-277,317.1-482.5,374.4c-69.1,19.3-142,29.5-217.2,29.5c-75.3,0-148.1-10.3-217.2-29.6 c-205.5-57.2-378-193.7-482.5-374.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "1946.3,1219 1951.3,1211.7 1946.3,1204.5  "
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "rays_x5F_spectrum__x28_\\u043A\\u043E\\u043F\\u0438\\u044F2_x29_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1551.2,1771.2c0,14-1.8,27.5-5.3,40.4c-2,7.4-4.5,14.5-7.5,21.4c-20.1,4.4-34.6,6.6-39.9,7.3 c-42.3,6.1-76.5,6.5-96.1,6.1c-30.9-0.6-54-3.5-69-5.4c-20.7-2.7-52.4-6.9-92.2-18.4c-4.6-1.3-24.1-7.1-49.3-16.9 c-27.9-10.9-48.7-21.2-57.8-25.9c-13.5-6.9-25.2-13.6-34.5-19.2c0,0,0,0,0,0c-0.3-0.2-0.6-0.3-0.9-0.5l147.9-548.3l299.1,518.1 c0.1,0.3,0.1,0.5,0.2,0.8c0,0,0,0,0,0.1C1549.4,1743.7,1551.2,1757.3,1551.2,1771.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1246.6,1211.9l-147.9,548.3c-10-6-17.2-10.7-20.6-13c-21.5-14.4-36.5-26.6-49.5-37.3 c-7.5-6.1-15.1-12.4-23.1-19.4c-6.5-5.7-13.2-11.8-20.2-18.6c0,0,0,0,0,0c-5.2-5.1-10.6-10.6-16.1-16.6 c-14.8-16-25.4-29.6-36.2-43.8c-0.8-1-1.6-2.1-2.4-3.1c-9.1-11.9-19.2-25.2-31.1-43.8c-9-14.2-18.2-28.7-27.6-49.2 c-7.5-16.3-11.6-29-15.6-41.2c-3-9.3-6.4-19.6-9.5-31.4l31.6-18.2L1246.6,1211.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1246.6,
    y1: 1211.9,
    x2: 1621.3,
    y2: 1861
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1246.6,1211.9c5.4,5.9,10,12.3,14.3,18.8c4.3,6.6,8.4,13.2,12.5,19.8c4.1,6.7,8,13.4,12,20.1l11.9,20.2 l46.8,81.1l93.7,162.3l93.7,162.3l46.8,81.1l46.7,81.2l-7.5,4.3l-47-81l-46.8-81.1l-93.7-162.3l-93.7-162.3l-46.9-81.1l-11.5-20.4 c-3.8-6.8-7.7-13.6-11.4-20.4c-3.7-6.9-7.4-13.8-10.9-20.7C1252.2,1226.7,1248.9,1219.6,1246.6,1211.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1246.6,
    y1: 1211.9,
    x2: 1440.6,
    y2: 1935.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1246.6,1211.9c3.7,7.1,6.5,14.4,9,21.8c2.4,7.4,4.7,14.9,6.9,22.4c2.2,7.5,4.3,15,6.4,22.5l6.3,22.6 l24.2,90.5l48.5,181l48.5,181l24.3,90.5l24.1,90.5l-8.3,2.2l-24.4-90.4l-24.3-90.5l-48.5-181l-48.5-181l-24.3-90.5l-5.8-22.7 c-2-7.6-3.9-15.1-5.8-22.7c-1.8-7.6-3.6-15.2-5.2-22.9C1248.1,1227.7,1246.9,1219.9,1246.6,1211.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1246.6,
    y1: 1211.9,
    x2: 1246.6,
    y2: 1961.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1246.6,1211.9c1.7,7.8,2.5,15.6,3,23.4c0.4,7.8,0.7,15.6,0.9,23.4c0.2,7.8,0.3,15.6,0.3,23.4l0.3,23.4 l0,93.7l0,187.3l0,187.3l0,93.7l-0.2,93.7h-8.6l-0.2-93.7l0-93.7l0-187.3l0-187.3l0-93.7l0.3-23.4c0.1-7.8,0.1-15.6,0.3-23.4 c0.2-7.8,0.5-15.6,0.9-23.4C1244,1227.5,1244.8,1219.7,1246.6,1211.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1246.6,
    y1: 1211.9,
    x2: 1051.4,
    y2: 1935.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1246.6,1211.9c-0.3,8-1.6,15.7-3.2,23.4c-1.6,7.6-3.4,15.3-5.2,22.9c-1.8,7.6-3.8,15.1-5.8,22.7l-5.9,22.7 l-24.4,90.5l-48.8,180.9l-48.8,180.9l-24.4,90.5l-24.6,90.4l-8.3-2.2l24.2-90.5l24.4-90.5l48.8-180.9l48.8-180.9l24.4-90.5 l6.3-22.5c2.1-7.5,4.2-15,6.4-22.5c2.2-7.5,4.5-14.9,7-22.4C1240,1226.3,1242.8,1219,1246.6,1211.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1246.6,
    y1: 1211.9,
    x2: 871.8,
    y2: 1861
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1246.6,1211.9c-2.4,7.6-5.6,14.8-9.1,21.8c-3.5,7-7.2,13.9-10.9,20.7c-3.7,6.9-7.6,13.6-11.4,20.4 l-11.5,20.4l-46.9,81.1l-93.7,162.3L969.4,1701l-46.8,81.1l-47,81l-7.5-4.3l46.7-81.2l46.8-81.1l93.7-162.3l93.7-162.3l46.8-81.1 l11.9-20.2c4-6.7,7.9-13.5,12-20.1c4.1-6.7,8.2-13.3,12.5-19.8C1236.6,1224.2,1241.1,1217.8,1246.6,1211.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1246.6,
    y1: 1211.9,
    x2: 716.7,
    y2: 1741.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1246.6,1211.9c-4.3,6.8-9.2,12.8-14.4,18.7c-5.2,5.8-10.5,11.5-15.9,17.2c-5.4,5.7-10.9,11.2-16.3,16.8 l-16.4,16.7l-66.2,66.2L984.8,1480l-132.5,132.5l-66.2,66.2l-66.4,66.1l-6.1-6.1l66.1-66.4l66.2-66.2l132.5-132.5l132.5-132.5 l66.2-66.2l16.7-16.4c5.6-5.5,11.1-11,16.8-16.3c5.7-5.4,11.4-10.7,17.2-15.9C1233.7,1221.2,1239.8,1216.2,1246.6,1211.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1246.6,
    y1: 1211.9,
    x2: 597.6,
    y2: 1586.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1246.6,1211.9c-5.9,5.4-12.3,10-18.8,14.3c-6.6,4.3-13.2,8.4-19.8,12.5c-6.7,4.1-13.4,8-20.1,12l-20.2,11.9 l-81.1,46.8l-162.2,93.7l-162.2,93.7l-81.1,46.8l-81.2,46.7l-4.3-7.5l81-47l81.1-46.8l162.2-93.7l162.2-93.7l81.1-46.8l20.4-11.5 c6.8-3.8,13.6-7.7,20.4-11.4c6.9-3.7,13.8-7.4,20.7-10.9C1231.8,1217.5,1238.9,1214.3,1246.6,1211.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1246.6,
    y1: 1211.9,
    x2: 522.6,
    y2: 1406.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1246.6,1211.9c-7.1,3.7-14.4,6.5-21.8,9c-7.4,2.4-14.9,4.7-22.4,6.9c-7.5,2.2-15,4.3-22.5,6.4l-22.6,6.3 l-90.5,24.3l-181,48.6l-181,48.6l-90.5,24.3l-90.5,24.1l-2.2-8.3l90.4-24.5l90.5-24.3l181-48.6l181-48.6l90.5-24.3l22.7-5.8 c7.6-2,15.1-3.9,22.7-5.8c7.6-1.8,15.2-3.6,22.9-5.2C1230.8,1213.5,1238.6,1212.3,1246.6,1211.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1239.2,1217.2"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "circle_x5F_red"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 1246.6,
    cy: 1211.9,
    r: 749.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "spherecover"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M546.9,1211.7c14.5,25,30.2,49.1,47.2,72.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M546.9,1211.7c139.7-241.5,400.7-403.9,699.7-403.9c90.1,0,176.7,14.7,257.6,42"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7bb26e698890fa2ee25258323e82c5ed.svg";
export { ForwardRef as ReactComponent };